import React from "react";
import './ServerNotificationModal.css';

function ServerNotificationModal({ show, title, message, onClose }) {
    if (!show) return null;

    return (
        <div className="server-notification-modal" onClick={onClose}>
            <div className="server-notification-content" onClick={(e) => e.stopPropagation()}>
                <div className="server-notification-header">
                    <h3>{title}</h3>
                    <span className="server-notification-close" onClick={onClose}>&times;</span>
                </div>
                <div className="server-notification-body">
                    <p>{message}</p>
                </div>
                <div className="server-notification-footer">
                    <button className="server-notification-ok" onClick={onClose}>OK</button>
                </div>
            </div>
        </div>
    );
}

export default ServerNotificationModal; 